


















import { GetServicesServiceNoMainDomainsResponse } from 'ncp-api-supporter';
import { Component, Prop } from 'vue-property-decorator';
import DomainSecurityConnectionMixin from './domainSecurityConnectionMixin';

@Component
export default class SslServerStatus extends DomainSecurityConnectionMixin {
  @Prop({ required: true })
  readonly type!: 'DOMAIN' | 'SSL';

  @Prop({ required: false })
  readonly platform: 'PC' | 'MOBILE';

  @Prop({ required: true })
  readonly domainSecurityInfo!: GetServicesServiceNoMainDomainsResponse;

  get status() {
    return this.type === 'DOMAIN'
      ? this.domainSecurityInfo.domainStatus
      : this.platform === 'PC' ? this.domainSecurityInfo.sslStatus : this.domainSecurityInfo.mobileSslStatus;
  }

  get statusColor() {
    return this.status === 'CONNECTED' || this.status === 'INSTALLED' ? 'text-green' : 'text-red';
  }

  get expirationDueDays() {
    return this.type === 'DOMAIN'
      ? this.domainSecurityInfo.domainExpirationDueDays
      : this.platform === 'PC' ? this.domainSecurityInfo.sslExpirationDueDays : this.domainSecurityInfo.mobileSslExpirationDueDays;
  }

  get shouldShowExpirationDueDays() {
    return (this.type === 'DOMAIN' ? this.status === 'CONNECTED' : this.isSslInstalled) && this.getIsExpiredClose(this.expirationDueDays);
  }

  get isSslInstalled() {
    return ['INSTALLED', 'WAITING_EXTENSION'].includes(this.status);
  }
}
